/* ============================================================
   NORTHSHEEP — first favourite on a touch screen teaches the swipe.

   Owner, 20 Sep 2026: "so that people will discover by liking a skin that
   they can simply swipe the card to the right".

   WHEN IT PLAYS
   The first time a visitor TAPS the heart on a collection card, on a touch
   screen, on a grid where the swipe gesture is switched on. Once per browser.

   WHY THAT MOMENT AND NOT ON ARRIVAL
   A hint on landing is an interruption: it costs attention before the shopper
   has decided they want anything. A tap on the heart is the opposite — it is
   proof of intent, and the demo answers a question they have just asked
   ("save this one") with a faster way to ask it again. That is also why it
   does not need any words: they already know what the outcome is, because
   they just chose it.

   WHO NEVER SEES IT
   - anyone on a mouse (the gesture there is a drag onto the heart zone, which
     the curate tutorial already demonstrates, and the card heart is a hover
     affordance anyway),
   - anyone who has already used the gesture (ns-collection-curate.js fires
     ns:fav-gesture, which marks this as learned),
   - anyone who asked for reduced motion,
   - anyone who taps the heart to UN-favourite.

   ?fav-swipe-demo=1 force-replays it for testing.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsFavSwipeHint) return;
  window.__nsFavSwipeHint = true;

  var KEY = 'northsheep_fav_swipe_hint_seen';
  var LS = (function () {
    try {
      localStorage.setItem('__t', '1');
      localStorage.removeItem('__t');
      return true;
    } catch (e) {
      return false;
    }
  })();
  function seen() {
    if (!LS) return true; // no storage = no way to remember, so never teach twice
    try {
      return localStorage.getItem(KEY) === '1';
    } catch (e) {
      return true;
    }
  }
  function markSeen() {
    if (!LS) return;
    try {
      localStorage.setItem(KEY, '1');
    } catch (e) {}
  }

  var FORCE = location.search.indexOf('fav-swipe-demo') !== -1;
  function mq(q) {
    return window.matchMedia ? window.matchMedia(q).matches : false;
  }
  var isTouch = mq('(hover: none) and (pointer: coarse)');
  function reduced() {
    return mq('(prefers-reduced-motion: reduce)');
  }

  /* They found it by themselves — there is nothing left to teach. Listened for
     on document because the grid is replaced wholesale by the Section
     Rendering API on every sort and filter. */
  document.addEventListener('ns:fav-gesture', markSeen);

  /* The lesson draws its own heart. It briefly borrowed one from
     ns-collection-curate.js, when every save stamped the card — that stamp is
     gone (the saved state stays red on the card, so it was confirming
     something already visible), but the LESSON still needs a big heart: it is
     teaching what the gesture means, which is a different job from confirming
     that it worked. Same path as the card hearts
     (snippets/ns-favorite-button.liquid), filled rather than outlined. */
  var HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.3l-1.45-1.32C5.4 14.36 2 11.28 2 7.78 2 4.92 4.2 2.7 7 2.7c1.74 0 3.4.86 4.45 2.23l.55.72.55-.72A5.5 5.5 0 0 1 17 2.7c2.8 0 5 2.22 5 5.08 0 3.5-3.4 6.58-8.55 11.2L12 20.3z"/>' +
    '</svg>';

  var timers = [];
  var running = false;
  var theCard = null;
  var theBtn = null;
  var burst = null;
  var onAbort = null;

  function after(ms, fn) {
    timers.push(setTimeout(fn, ms));
  }

  function cleanup() {
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    timers = [];
    if (burst) {
      burst.remove();
      burst = null;
    }
    if (theCard) {
      theCard.style.transition = '';
      theCard.style.transform = '';
      theCard.classList.remove('ns-favhint-card');
    }
    if (theBtn) {
      theBtn.classList.remove('ns-favhint-hold', 'ns-favhint-pop');
    }
    document.documentElement.classList.remove('ns-curate-clipx');
    if (onAbort) {
      window.removeEventListener('scroll', onAbort);
      document.removeEventListener('pointerdown', onAbort, true);
      onAbort = null;
    }
    theCard = null;
    theBtn = null;
    running = false;
  }

  function play(card, btn) {
    if (running) return;
    running = true;
    theCard = card;
    theBtn = btn;

    /* The page must not widen while the card travels to the right. The curate
       engine solves this for the real gesture with a class on <html>; the demo
       borrows the same one rather than inventing a second answer. */
    document.documentElement.classList.add('ns-curate-clipx');

    /* Anything the shopper does outright cancels it: a demo that keeps playing
       while someone scrolls away is just a card moving on its own. */
    onAbort = function () {
      cleanup();
    };
    window.addEventListener('scroll', onAbort, { passive: true, once: true });
    document.addEventListener('pointerdown', onAbort, true);

    card.classList.add('ns-favhint-card');
    btn.classList.add('ns-favhint-hold');

    /* 1. The card slides right, tilting slightly — the same rotation the real
          swipe applies (dx * 0.04, capped at 8deg), so the demo looks like the
          gesture rather than like a different animation. */
    after(160, function () {
      card.style.transition = 'transform 320ms cubic-bezier(0.22, 0.61, 0.36, 1)';
      card.style.transform = 'translateX(66px) rotate(2.6deg)';
    });

    /* 2. The big heart, at the moment the card is furthest out. */
    after(300, function () {
      burst = document.createElement('div');
      burst.className = 'ns-favhint-burst';
      burst.setAttribute('aria-hidden', 'true');
      burst.innerHTML = HEART;
      card.appendChild(burst);
    });

    /* 3. The card settles back into its slot. The real gesture ends the same
          way — a favourite snaps back, only a hide flies off. */
    after(620, function () {
      card.style.transition = 'transform 340ms cubic-bezier(0.22, 0.61, 0.36, 1)';
      card.style.transform = '';
    });

    /* 4. And the corner heart arrives red, which is the state they are left
          in. */
    after(940, function () {
      btn.classList.remove('ns-favhint-hold');
      btn.classList.add('ns-favhint-pop');
    });

    after(1400, cleanup);
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-ns-fav-btn]') : null;
      if (!btn) return;
      if (!FORCE) {
        if (!isTouch || seen() || reduced()) return;
      }

      var card = btn.closest('[data-ns-card-handle]');
      if (!card) return;
      /* Only where the gesture exists. In "zones" mode a touch drag is a page
         scroll, so teaching a swipe there would teach something that does not
         work. */
      if (!card.closest('ul#product-grid[data-ns-actions="swipe"]')) return;

      /* ns-favorites.js owns the click; let it finish before reading the
         result. A tap that REMOVES a favourite is not the moment for this —
         the demo would be showing the way to do the opposite of what they
         just did. */
      setTimeout(function () {
        if (!btn.classList.contains('is-favorite')) return;
        /* Marked before the animation, never after: if anything below throws,
           or the shopper leaves mid-way, the hint is spent rather than saved
           up to ambush them on every future visit. */
        markSeen();
        play(card, btn);
      }, 70);
    },
    false
  );
})();
